export type WordGardenSkillKind =
  | 'context-clues'
  | 'synonyms'
  | 'antonyms'
  | 'multiple-meaning'
  | 'shades-of-meaning';

export interface WordGardenChoice {
  readonly id: string;
  readonly meaning: string;
}

export interface WordGardenHint {
  readonly message: string;
  readonly highlightText?: string;
}

export interface WordGardenConfig {
  readonly id: string;
  readonly skillId: string;
  readonly skillKind: WordGardenSkillKind;
  readonly title: string;
  readonly sentence: string;
  readonly targetWord: string;
  readonly choices: readonly WordGardenChoice[];
  readonly correctChoiceId: string;
  readonly hints: readonly WordGardenHint[];
  readonly completionWorldEvent: string;
  readonly successMessage: string;
}

export function validateWordGardenConfig(config: WordGardenConfig) {
  if (config.choices.length < 2) {
    throw new RangeError(`Word Garden challenge "${config.id}" needs at least two choices.`);
  }

  const choiceIds = config.choices.map(choice => choice.id);
  if (new Set(choiceIds).size !== choiceIds.length) {
    throw new Error(`Word Garden challenge "${config.id}" contains duplicate choice ids.`);
  }
  if (!choiceIds.includes(config.correctChoiceId)) {
    throw new Error(`Word Garden challenge "${config.id}" has no matching correct choice.`);
  }
  if (!config.sentence.toLocaleLowerCase().includes(config.targetWord.toLocaleLowerCase())) {
    throw new Error(`Word Garden challenge "${config.id}" must include its target word in the sentence.`);
  }
  if (config.hints.length < 3) {
    throw new RangeError(`Word Garden challenge "${config.id}" needs three progressive hints.`);
  }
}
